import { useSelect } from "@refinedev/antd";
import { IProductType } from "interfaces";
import { APP_WRITE_PRODUCT_TYPE_ID } from "utility/constants";

export const ProductTypeSelectOptions= () => {
  const { selectProps: productTypeSelectProps } = useSelect<IProductType>({
    resource: APP_WRITE_PRODUCT_TYPE_ID,
    optionLabel: "Name",
    optionValue: "id",
    sorters: [
      {
        field: "Name",
        order: "asc",
      },
    ],
  });
  return (
    {productTypeSelectProps}
  );
};